import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import AIPrograms from "@/pages/AIPrograms";
import Enrollment from "@/pages/Enrollment";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import StudentLogin from "@/pages/StudentLogin";
import StudentDashboard from "@/pages/StudentDashboard";
import StudentCourses from "@/pages/StudentCourses";
import StudentAssignments from "@/pages/StudentAssignments";
import StudentResources from "@/pages/StudentResources";
import StudentQuiz from "@/pages/StudentQuiz";
import StudentMessages from "@/pages/StudentMessages";
import StudentCertificates from "@/pages/StudentCertificates";
import StudentGamification from "@/pages/StudentGamification";
import ParentLogin from "@/pages/ParentLogin";
import ParentDashboard from "@/pages/ParentDashboard";
import TeacherLogin from "@/pages/TeacherLogin";
import TeacherRegister from "@/pages/TeacherRegister";
import TeacherDashboard from "@/pages/TeacherDashboard";
import PasswordReset from "@/pages/PasswordReset";
import Support from "@/pages/Support";
import Donate from "@/pages/Donate";
import ProjectBoard from "@/pages/ProjectBoard";
import ShareableAchievement from "@/pages/ShareableAchievement";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-[#060F22] flex flex-col">
        <BrowserRouter>
          <Navbar />
          <main className="flex-grow">
            <Routes>
              {/* Public Pages */}
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/programs/ai" element={<AIPrograms />} />
              <Route path="/enrollment" element={<Enrollment />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/reset-password" element={<PasswordReset />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/projects" element={<ProjectBoard />} />
              <Route path="/achievements/share/:type/:id" element={<ShareableAchievement />} />
              
              {/* Student Portal */}
              <Route path="/student/login" element={<StudentLogin />} />
              <Route path="/student/reset-password" element={<PasswordReset />} />
              <Route path="/student/dashboard" element={<StudentDashboard />} />
              <Route path="/student/courses" element={<StudentCourses />} />
              <Route path="/student/courses/:slug" element={<StudentCourses />} />
              <Route path="/student/assignments" element={<StudentAssignments />} />
              <Route path="/student/assignment/:lessonId" element={<StudentAssignments />} />
              <Route path="/student/resources" element={<StudentResources />} />
              <Route path="/student/quiz/:quizId" element={<StudentQuiz />} />
              <Route path="/student/messages" element={<StudentMessages />} />
              <Route path="/student/messages/:messageId" element={<StudentMessages />} />
              <Route path="/student/certificates" element={<StudentCertificates />} />
              <Route path="/student/achievements" element={<StudentGamification />} />
              <Route path="/student/support" element={<Support />} />
              
              {/* Parent Portal */}
              <Route path="/parent/login" element={<ParentLogin />} />
              <Route path="/parent/reset-password" element={<PasswordReset />} />
              <Route path="/parent/dashboard" element={<ParentDashboard />} />
              <Route path="/parent/support" element={<Support />} />
              
              {/* Teacher Portal */}
              <Route path="/teacher/login" element={<TeacherLogin />} />
              <Route path="/teacher/register" element={<TeacherRegister />} />
              <Route path="/teacher/reset-password" element={<PasswordReset />} />
              <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
              <Route path="/teacher/support" element={<Support />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster 
          position="top-right" 
          richColors 
          toastOptions={{
            style: {
              background: '#0A1F44',
              color: '#F5F7FA',
              border: '1px solid rgba(0, 174, 239, 0.2)',
            },
          }}
        />
      </div>
    </AuthProvider>
  );
}

export default App;
